import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { logger } from '@/services/logger/loggers'
import { loadUserData } from '@/store'
import { registerRoutesAndMiddlewares } from './router/routes'
import { startTracking } from './services/tracking'
import '@/modules/senndrive/index.css'

async function initialize() {
  window.onerror = function (message, url, line, column, error) {
    logger.error('[driver-web-app- global error]', { error })
  }
  await loadUserData()
}

async function start() {
  // TODO: if required, check for user cookie consent before starting tracking
  startTracking()

  try {
    await initialize()
  } catch (error) {
    logger.error(`[driver-web-app - bootstrap]: Bootstrap error`, { error })
  } finally {
    registerRoutesAndMiddlewares(router) // Ensure routes are registered before mounting
    const app = createApp(App)
    app.use(router)
    // OPTIONAL: Register necessary plugins here, like: GTM, i18n
    app.mount('#app')
  }
}

start()
